import cx from "classnames";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import "./RadioOptions.css";

const RadioOptions = (props) => {
    const {
        options, value, onChange, className, error,
        disabled,
    } = props;

    return (
        <FormControl error={!!error} className="w-full">
            <RadioGroup
                className={cx("radio-options", className)}
                value={value}
                onChange={onChange}
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio />}
                        className="radio-options__label"
                        label={option.label}
                        labelPlacement="end"
                        disabled={disabled}
                    />
                ))}
            </RadioGroup>
            {error ? <FormHelperText>{error}</FormHelperText> : null}
        </FormControl>
    );
};

export default RadioOptions;
